import axios from "axios";
import { store } from "../store/store";
import { getResponseMessage } from "../assets/js/utils";

export default {
  async getStores(area) {
    return axios
      .get(`/restaurant/area/like?areaName=${area}`)
      .then(response => { return response.data })
      .catch(error => console.log(error.response))
  },

  async getStoreReviews(storeId, page) {
    return axios
      .get(`/review/store/${storeId}?page=${page}&resultsPerPage=15`)
      .then(response => { return response.data })
      .catch(error => console.log(error.response))
  },

  async getStoreByTableIdAndService(tableId, service, isPda) {
    let endpoint = `/store?tableId=${tableId}&departmentName=${service}`;
    if (isPda) {
      endpoint = endpoint + "&isPda=true";
    }
    let result = await axios
      .get(endpoint)
      .catch((error) => console.log(error.response));

    return result.data;
  },

  async getStoreById(id) {
    return axios
      .get(`/store/${id}`)
      .then(response => { return response.data })
      .catch((error) => console.log(error.response));
  },

  async getTable(tableId) {
    return axios
      .get(`/restaurant/table?tableId=${tableId}`)
      .then(response => { return response.data })
      .catch((error) => console.log(error.response));
  },

  async getOrderLimit(restaurantId) {
    return axios
      .get(`/restaurant/order-limit?restaurantId=${restaurantId}`)
      .then(response => { return response.data })
      .catch((error) => console.log(error.response));
  },

  async getListOfRooms(storeId, isStoreSplitInSections, tableSection, setResponseAsTables) {
    let sectionParameter = ""

    if (isStoreSplitInSections) {
      sectionParameter = `&section=${tableSection}`
    }

    return axios
      .get(`/store/hotel-rooms?storeId=${storeId}${sectionParameter}`)
      .then(response => {
        if (setResponseAsTables) {
          store.dispatch("setAvailableTables", response.data);
        }
        return response.data;
      })
      .catch((error) => console.log(error.response));
  },

  async getHotelizerListOfRooms(storeId) {
    return axios
      .get(`/store/hotelizer/hotel-rooms?storeId=${storeId}`)
      .then(response => {
        return response.data;
      })
      .catch((error) => console.log(error.response));
  },

  async getChargingRooms(storeId) {
    return axios
      .get(`/store/hotel-rooms?storeId=${storeId}`)
      .then(response => {
        store.dispatch("setAvailableChargingRooms", response.data);
        return response.data;
      })
      .catch((error) => console.log(error.response));
  },

  async getListOfAvailableTables(storeId, fetchTablesPerSection, restaurantId, tableType, tableSection) {

    let sectionParameter = ""

    if (fetchTablesPerSection) {
      sectionParameter = `&section=${tableSection}`
    }

    return axios
      .get(`/store/tables?storeId=${storeId}&restaurantId=${restaurantId}&type=${tableType}${sectionParameter}`)
      .then(response => {
        store.dispatch("setAvailableTables", response.data);
        return response.data;
      })
      .catch((error) => console.log(error.response));
  },

  async getAllTablesOfStore(storeId) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .get(`${adminBaseUrl}/store/tables?storeId=${storeId}`)
      .then(response => {
        return response.data;
      })
      .catch((error) => console.log(error.response));
  },

  async getAllAvailableTablesForRestaurant(storeId, restaurantId, section) {
    return axios
      .get(`/store/all-tables?storeId=${storeId}&restaurantId=${restaurantId}&section=${section}`)
      .then(response => {
        store.dispatch("setAvailableTables", response.data);
        return response.data;
      })
      .catch((error) => console.log(error.response));
  },

  async getTablesWithOpeningsForRestaurant(storeId, restaurantId) {
    return axios
      .get(`/store/all-tables-with-openings?storeId=${storeId}&restaurantId=${restaurantId}`)
      .then(response => {
        store.dispatch("setTablesWithOpenings", response.data);
        return response.data;
      })
      .catch((error) => console.log(error.response));
  },

  async getAllAvailableTablesAndPackagesOfStore(storeId, section) {
    return axios
      .get(`/store/tables-and-packages?storeId=${storeId}&section=${section}`)
      .then(response => {
        store.dispatch("setAvailableTables", response.data);
        return response.data
      })
      .catch((error) => console.log(error.response));
  },

  async getRestaurantsWithTableOpenings(storeId, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .get(`${adminBaseUrl}/restaurant/of-type-table-opening?storeId=${storeId}`, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
      });
  },

  async fetchAllSpotsForRestaurants(storeId, restaurantIds) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .get(`${adminBaseUrl}/store/all-spots-of-restaurants?storeId=${storeId}&restaurantIds=${restaurantIds}`, {
        headers: {
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
      });
  },

  async getMenuRestaurants(storeId, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .get(`${adminBaseUrl}/restaurant/of-type-just-menu?storeId=${storeId}`, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
      });
  },

  async getRestaurantsWithRoomOpenings(storeId, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .get(`${adminBaseUrl}/restaurant/of-type-room-opening?storeId=${storeId}`, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
      });
  },

  async getCardTerminalsForRestaurants(restaurantIds, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .get(`${adminBaseUrl}/restaurant/card-terminals?restaurantIds=${restaurantIds}`, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
      });
  },

  async getTableSections(storeId, setAsTableFamilySections) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .get(`${adminBaseUrl}/store/sections/tables?storeId=${storeId}`, {
        headers: {
        },
      })
      .then((response) => {
        if (setAsTableFamilySections) {
          store.dispatch("setTableFamilySections", response.data);
        }
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
      });
  },

  async getHotelRoomSections(storeId) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .get(`${adminBaseUrl}/store/sections/hotel-rooms?storeId=${storeId}`, {
        headers: {
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
      });
  },

  async getPricesForClosedTables(restaurantIds, tableIds, userIds, startingDate, endingDate, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;

    let userIdsParameter = "";
    if (userIds.length > 0) {
      userIdsParameter = `&userIds=${userIds}`
    }
    return axios
      .get(`${adminBaseUrl}/table-opening/prices-for-closed?restaurantIds=${restaurantIds}&tableIds=${tableIds}${userIdsParameter}`, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
          "STARTING-DATE": startingDate,
          "ENDING-DATE": endingDate
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
      });
  },

  async getClosedTableOpenings(restaurantIds, tableIds, userIds, startingDate, endingDate, page, resultsPerPage, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;

    let userIdsParameter = "";
    if (userIds != null && userIds != undefined && userIds.length > 0) {
      userIdsParameter = `&userIds=${userIds}`
    }
    return axios
      .get(`${adminBaseUrl}/table-opening/fetch-closed?restaurantIds=${restaurantIds}&tableIds=${tableIds}&page=${page}&resultsPerPage=${resultsPerPage}${userIdsParameter}`, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
          "STARTING-DATE": startingDate,
          "ENDING-DATE": endingDate
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
      });
  },

  async getPricesForActions(restaurantIds, tableIds, userIds, startingDate, endingDate, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;

    let userIdsParameter = "";
    if (userIds.length > 0) {
      userIdsParameter = `&userIds=${userIds}`
    }
    return axios
      .get(`${adminBaseUrl}/table-opening-action/prices?restaurantIds=${restaurantIds}&tableIds=${tableIds}${userIdsParameter}`, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
          "STARTING-DATE": startingDate,
          "ENDING-DATE": endingDate
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
      });
  },

  async getPricesForActionsCombined(restaurantIds, tableIds, userIds, startingDate, endingDate, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .get(`${adminBaseUrl}/table-opening-action/prices-for-combined-users?restaurantIds=${restaurantIds}&tableIds=${tableIds}&userIds=${userIds}`, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
          "STARTING-DATE": startingDate,
          "ENDING-DATE": endingDate
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
      });
  },

  async sendAdminSalesForPrint(restaurantId, salesOfWaiter, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;

    return axios
      .post(`${adminBaseUrl}/table-opening/send-admin-sales-for-print?restaurantId=${restaurantId}`, salesOfWaiter, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
          "Content-Type": "application/json"
        },
      })
      .catch((error) => {
        console.log(error.response)
      });
  },

  async sendTempReceiptsReport(restaurantId, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .post(`${adminBaseUrl}/table-opening/send-temp-receipts-report?restaurantId=${restaurantId}`, null, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt
        },
      })
      .catch((error) => {
        console.log(error.response)
      });
  },

  async getPricesForClosedTablesCombined(restaurantIds, tableIds, userIds, startingDate, endingDate, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .get(`${adminBaseUrl}/table-opening/prices-for-closed-combined-users?restaurantIds=${restaurantIds}&tableIds=${tableIds}&userIds=${userIds}`, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
          "STARTING-DATE": startingDate,
          "ENDING-DATE": endingDate
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
      });
  },

  async getProductSales(restaurantId, typeOfSales, startingDate, endingDate, userId, tableId, orderOrigin, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;

    let userIdParameter = "";
    if (userId != null) {
      userIdParameter = `&userId=${userId}`;
    }

    let tableIdParameter = "";
    if (tableId != null) {
      tableIdParameter = `&tableId=${tableId}`;
    }

    let orderOriginParameter = "";
    if (orderOrigin != null) {
      orderOriginParameter = `&orderOrigin=${orderOrigin}`;
    }

    return axios
      .get(`${adminBaseUrl}/statistics/v3/sales?restaurantId=${restaurantId}&typeOfSales=${typeOfSales}${userIdParameter}${tableIdParameter}${orderOriginParameter}`, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
          "STARTING-DATE": startingDate,
          "ENDING-DATE": endingDate
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
      });
  },

  async getSubselectionSales(restaurantId, productId, typeOfSales, startingDate, endingDate, userId, tableId, orderOrigin, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;

    let userIdParameter = "";
    if (userId != null) {
      userIdParameter = `&userId=${userId}`;
    }

    let tableIdParameter = "";
    if (tableId != null) {
      tableIdParameter = `&tableId=${tableId}`;
    }

    let orderOriginParameter = "";
    if (orderOrigin != null) {
      orderOriginParameter = `&orderOrigin=${orderOrigin}`;
    }

    return axios
      .get(`${adminBaseUrl}/statistics/suboption-sales?restaurantId=${restaurantId}&productId=${productId}&typeOfSales=${typeOfSales}${userIdParameter}${tableIdParameter}${orderOriginParameter}`, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
          "STARTING-DATE": startingDate,
          "ENDING-DATE": endingDate
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
      });
  },

  async getTotalAmountOfClosedTables(restaurantIds, tableIds, userIds, startingDate, endingDate, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;

    let userIdsParameter = "";
    if (userIds.length > 0) {
      userIdsParameter = `&userIds=${userIds}`
    }
    return axios
      .get(`${adminBaseUrl}/table-opening/total-amount-of-closed?restaurantIds=${restaurantIds}&tableIds=${tableIds}${userIdsParameter}`, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
          "STARTING-DATE": startingDate,
          "ENDING-DATE": endingDate
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
      });
  },

  async getTableOpeningsForRestaurant(restaurantId, tableTypes, authToken, jwt, useIntervalApi) {
    let adminBaseUrl = useIntervalApi ? process.env.VUE_APP_ADMIN_INTERVAL_URL : process.env.VUE_APP_ADMIN_URL;
    return axios
      .get(`${adminBaseUrl}/table-opening/v3/fetch-open?restaurantId=${restaurantId}&tableTypes=${tableTypes}`, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        if (useIntervalApi) {
          let errorResponse = {
            error: true
          }
          return errorResponse;
        }
      });
  },

  async fetchAllWaiters(restaurantIds, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .get(`${adminBaseUrl}/staff/all-waiters?restaurantIds=${restaurantIds}`, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
      });
  },

  async fetchOpenTable(tableOpeningId, restaurantId, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .get(`${adminBaseUrl}/table-opening/by-id/${tableOpeningId}?restaurantId=${restaurantId}`, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
      });
  },

  async fetchActiveWaiters(restaurantIds, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .get(`${adminBaseUrl}/staff/active-waiters?restaurantIds=${restaurantIds}`, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
      });
  },

  async getTablesWithOpeningsOfRestaurants(storeId, restaurantIds) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .get(`${adminBaseUrl}/store/tables-with-openings-of-restaurants?storeId=${storeId}&restaurantIds=${restaurantIds}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async closeTableOpeningForRestaurant(restaurantId, payload, typeOfReceiptAfterClose, cardTerminalId, isPaidToExternalServer, authToken, jwt) {
    let adminBaseUrl = isPaidToExternalServer ? process.env.VUE_APP_PAYMENTS_SERVER_URL : process.env.VUE_APP_ADMIN_URL;

    let typeOfReceiptAfterCloseParameter = "";
    if (typeOfReceiptAfterClose != null && typeOfReceiptAfterClose != 'NO_RECEIPT_AFTER_CLOSE') {
      typeOfReceiptAfterCloseParameter = `&typeOfReceiptAfterClose=${typeOfReceiptAfterClose}`;
    }

    let cardTerminalIdParameter = "";
    if (cardTerminalId != null) {
      cardTerminalIdParameter = `&cardTerminalId=${cardTerminalId}`;
    }

    return axios
      .put(`${adminBaseUrl}/table-opening/close-table?restaurantId=${restaurantId}${typeOfReceiptAfterCloseParameter}${cardTerminalIdParameter}`, payload, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async closeTableOpeningBySpecificUserForRestaurant(restaurantId, payload, typeOfReceiptAfterClose, cardTerminalId, userId, isPaidToExternalServer, authToken, jwt) {
    let adminBaseUrl = isPaidToExternalServer ? process.env.VUE_APP_PAYMENTS_SERVER_URL : process.env.VUE_APP_ADMIN_URL;

    let typeOfReceiptAfterCloseParameter = "";
    if (typeOfReceiptAfterClose != null && typeOfReceiptAfterClose != 'NO_RECEIPT_AFTER_CLOSE') {
      typeOfReceiptAfterCloseParameter = `&typeOfReceiptAfterClose=${typeOfReceiptAfterClose}`;
    }

    let cardTerminalIdParameter = "";
    if (cardTerminalId != null) {
      cardTerminalIdParameter = `&cardTerminalId=${cardTerminalId}`;
    }

    return axios
      .put(`${adminBaseUrl}/table-opening/close-table/by-specific-user?userId=${userId}&restaurantId=${restaurantId}${typeOfReceiptAfterCloseParameter}${cardTerminalIdParameter}`, payload, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async assignTable(restaurantId, tableOpeningId, userId, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .put(`${adminBaseUrl}/table-opening/assign-table?restaurantId=${restaurantId}&tableOpeningId=${tableOpeningId}&userId=${userId}`, null, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async transferTableOpening(tableOpeningId, tableToTransferId, restaurantId, restaurantIdToTransferTable, pdaUserId, authToken, jwt) {

    let pdaUserIdParameter = "";
    if (pdaUserId != null) {
      pdaUserIdParameter = `&pdaUserId=${pdaUserId}`;
    }

    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .put(`${adminBaseUrl}/table-opening/waiter/tranfer-table/${tableOpeningId}?tableToTransferId=${tableToTransferId}&restaurantId=${restaurantId}&restaurantIdToTransferTable=${restaurantIdToTransferTable}${pdaUserIdParameter}`, null, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async editNote(restaurantId, tableOpeningId, note, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .put(`${adminBaseUrl}/table-opening/edit-note?restaurantId=${restaurantId}&tableOpeningId=${tableOpeningId}`, note, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
          "Content-Type": "text/plain"
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async editMinimumConsumption(restaurantId, tableOpeningId, minimumConsumption, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .put(`${adminBaseUrl}/table-opening/edit-minimum-consumption?restaurantId=${restaurantId}&tableOpeningId=${tableOpeningId}`, minimumConsumption, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
          "Content-Type": "text/plain"
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async payPartialBeforeClose(restaurantIds, payload, publishAndReceipt, userId, isPaidToExternalServer, authToken, jwt) {

    let userIdParameter = "";
    if (userId != null) {
      userIdParameter = `&userId=${userId}`;
    }

    let adminBaseUrl = isPaidToExternalServer ? process.env.VUE_APP_PAYMENTS_SERVER_URL : process.env.VUE_APP_ADMIN_URL;
    return axios
      .put(`${adminBaseUrl}/table-opening/pay-partial-before-close?restaurantIds=${restaurantIds}&publishAndReceipt=${publishAndReceipt}${userIdParameter}`, payload, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },


  async putDiscount(tableOpeningId, restaurantId, userId, discount, authToken, jwt) {

    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .put(`${adminBaseUrl}/table-opening/put-discount?restaurantId=${restaurantId}&tableOpeningId=${tableOpeningId}&userId=${userId}&discount=${discount}`, null, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async calibrate(tableOpeningId, restaurantId, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .put(`${adminBaseUrl}/table-opening/calibrate?tableOpeningId=${tableOpeningId}&restaurantId=${restaurantId}`, null, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async executeOrders(tableOpeningId, restaurantId, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .put(`${adminBaseUrl}/table-opening/execute-orders?tableOpeningId=${tableOpeningId}&restaurantId=${restaurantId}`, null, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async restartCashRegister(restaurantIds, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .put(`${adminBaseUrl}/restaurant/restart-cash-register?restaurantIds=${restaurantIds}`, null, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async createAllNonPublishedTempReceipts(restaurantId, printTemps, userId, authToken, jwt) {

    let userIdParameter = "";
    if (userId != null) {
      userIdParameter = `&userId=${userId}`;
    }

    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .post(`${adminBaseUrl}/restaurant/generate-non-published-tempreceipts?restaurantId=${restaurantId}&print=${printTemps}${userIdParameter}`, null, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async generateTempReceiptForOrder(orderId, restaurantId, userId, clientId) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;

    let clientIdParameter = "";
    if (clientId != null) {
      clientIdParameter = `&clientId=${clientId}`;
    }

    let userIdParameter = "";
    if (userId != null) {
      userIdParameter = `&userId=${userId}`;
    }

    return axios
      .put(`${adminBaseUrl}/table-opening/generate-temp-receipt-for-order?orderId=${orderId}&restaurantId=${restaurantId}${clientIdParameter}${userIdParameter}`, null, {
        headers: {
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async generateFinalReceiptForOrder(orderId, restaurantId, cardTerminalId, userId, invoiceDetailsRequest, isPaidToExternalServer, isIrisPayment, clientId) {

    let cardTerminalIdParameter = "";
    if (cardTerminalId != null) {
      cardTerminalIdParameter = `&cardTerminalId=${cardTerminalId}`;
    }

    let userIdParameter = "";
    if (userId != null) {
      userIdParameter = `&userId=${userId}`;
    }

    let clientIdParameter = "";
    if (clientId != null) {
      clientIdParameter = `&clientId=${clientId}`;
    }

    let adminBaseUrl = isPaidToExternalServer ? process.env.VUE_APP_PAYMENTS_SERVER_URL : process.env.VUE_APP_ADMIN_URL;

    return axios
      .put(`${adminBaseUrl}/table-opening/generate-final-receipt-for-order?orderId=${orderId}&restaurantId=${restaurantId}&isIrisPayment=${isIrisPayment}${cardTerminalIdParameter}${userIdParameter}${clientIdParameter}`, invoiceDetailsRequest, {
        headers: {
          "Content-Type": "application/json"
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async generateDispatchNoteForOrder(orderId, restaurantId, userId, invoiceDetailsRequest, isPaidToExternalServer, clientId, authToken, jwt) {

    let userIdParameter = "";
    if (userId != null) {
      userIdParameter = `&userId=${userId}`;
    }

    let clientIdParameter = "";
    if (clientId != null) {
      clientIdParameter = `&clientId=${clientId}`;
    }

    let adminBaseUrl = isPaidToExternalServer ? process.env.VUE_APP_PAYMENTS_SERVER_URL : process.env.VUE_APP_ADMIN_URL;

    return axios
      .put(`${adminBaseUrl}/table-opening/generate-dispatch-note-for-order?orderId=${orderId}&restaurantId=${restaurantId}${userIdParameter}${clientIdParameter}`, invoiceDetailsRequest, {
        headers: {
          "Content-Type": "application/json",
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },


  async sendTempReceiptForPrint(receiptId, restaurantId, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .post(`${adminBaseUrl}/table-opening/send-temp-receipt-for-print?receiptId=${receiptId}&restaurantId=${restaurantId}`, null, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async sendFinalReceiptForPrint(receiptId, restaurantId, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .post(`${adminBaseUrl}/table-opening/send-final-receipt-for-print?receiptId=${receiptId}&restaurantId=${restaurantId}`, null, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async fetchTempReceiptsForTableOpening(tableOpeningId, restaurantId, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .get(`${adminBaseUrl}/table-opening/get-temp-receipts?tableOpeningId=${tableOpeningId}&restaurantId=${restaurantId}`, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async fetchFinalReceiptsForTableOpening(tableOpeningId, restaurantId, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .get(`${adminBaseUrl}/table-opening/get-final-receipts?tableOpeningId=${tableOpeningId}&restaurantId=${restaurantId}`, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async generateTempReceipt(restaurantId, payload, userId, authToken, jwt) {
    let userIdParameter = "";
    if (userId != null) {
      userIdParameter = `&userId=${userId}`;
    }

    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .post(`${adminBaseUrl}/table-opening/generate-temp-receipt?restaurantId=${restaurantId}${userIdParameter}`, payload, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async generateFinalReceipt(restaurantId, payload, isSelfDeliveryReceipt, userId, authToken, jwt) {
    let userIdParameter = "";
    if (userId != null) {
      userIdParameter = `&userId=${userId}`;
    }

    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .post(`${adminBaseUrl}/table-opening/generate-final-receipt?restaurantId=${restaurantId}&isSelfDeliveryReceipt=${isSelfDeliveryReceipt}&paymentType=${payload.paymentType}${userIdParameter}`, payload, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async generateTempSelfDeliveryReceipt(restaurantId, tableOpeningId, amount, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    let amountFixed = Number(amount).toFixed(2);
    return axios
      .post(`${adminBaseUrl}/table-opening/generate-temp-self-delivery-receipt?restaurantId=${restaurantId}&tableOpeningId=${tableOpeningId}&amount=${amountFixed}`, null, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async generateFinalReceiptFromTemps(receiptIds, restaurantId, paymentType, isSelfDeliverReceipt, cardTerminalId, cardTip, invoiceDetailsRequest, userId, isIrisPayment, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    let isInvoice = invoiceDetailsRequest != null;

    let cardTerminalIdParameter = "";
    if (cardTerminalId != null) {
      cardTerminalIdParameter = `&cardTerminalId=${cardTerminalId}`;
    }

    let userIdParameter = "";
    if (userId != null) {
      userIdParameter = `&userId=${userId}`;
    }

    let cardTipParameter = "";
    if (cardTip != null && cardTip > 0) {
      cardTipParameter = `&cardTip=${cardTip}`;
    }

    return axios
      .post(`${adminBaseUrl}/table-opening/generate-final-receipt-from-temps?receiptIds=${receiptIds}&restaurantId=${restaurantId}&paymentType=${paymentType}&isInvoice=${isInvoice}&isIrisPayment=${isIrisPayment}&isSelfDeliverReceipt=${isSelfDeliverReceipt}${cardTerminalIdParameter}${userIdParameter}${cardTipParameter}`, invoiceDetailsRequest, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
          "Content-Type": "application/json"
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async fetchCompanyByVat(restaurantId, vat, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .get(`${adminBaseUrl}/table-opening/company-details?restaurantId=${restaurantId}&vat=${vat}`, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async cancelTempReceipts(receiptIds, restaurantId, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .post(`${adminBaseUrl}/table-opening/cancel-temp-receipts?receiptIds=${receiptIds}&restaurantId=${restaurantId}`, null, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async updateReceiptToCardPayment(receiptId, restaurantId, cardTerminalId, authToken, jwt) {

    let cardTerminalIdParameter = "";
    if (cardTerminalId != null) {
      cardTerminalIdParameter = `&cardTerminalId=${cardTerminalId}`;
    }

    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .put(`${adminBaseUrl}/table-opening/update-receipt-to-card-payment/${receiptId}?restaurantId=${restaurantId}${cardTerminalIdParameter}`, null, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async chargeToRoom(restaurantIds, payload, publishAndReceipt, userId, authToken, jwt) {

    let userIdParameter = "";
    if (userId != null) {
      userIdParameter = `&userId=${userId}`;
    }

    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .put(`${adminBaseUrl}/table-opening/charge-to-room?restaurantIds=${restaurantIds}&publishAndReceipt=${publishAndReceipt}${userIdParameter}`, payload, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async partialTransfer(restaurantIds, payload, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .put(`${adminBaseUrl}/table-opening/partial-transfer?restaurantIds=${restaurantIds}`, payload, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async cancelProducts(restaurantIds, payload, userId, authToken, jwt) {

    let userIdParameter = "";
    if (userId != null) {
      userIdParameter = `&userId=${userId}`;
    }

    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .put(`${adminBaseUrl}/table-opening/cancel-products?restaurantIds=${restaurantIds}${userIdParameter}`, payload, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async treatProducts(restaurantIds, payload, publishAndReceipt, userId, authToken, jwt) {

    let userIdParameter = "";
    if (userId != null) {
      userIdParameter = `&userId=${userId}`;
    }

    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .put(`${adminBaseUrl}/table-opening/treat-products?restaurantIds=${restaurantIds}&publishAndReceipt=${false}${userIdParameter}`, payload, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async cancelReceipt(restaurantId, receiptId, userId, authToken, jwt) {

    let userIdParameter = "";
    if (userId != null) {
      userIdParameter = `&userId=${userId}`;
    }

    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .post(`${adminBaseUrl}/table-opening/cancel-final-receipt?restaurantId=${restaurantId}&receiptId=${receiptId}${userIdParameter}`, null, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },


  async reOpenTable(tableOpeningId, restaurantId, userId, authToken, jwt) {

    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;

    let userIdParameter = "";
    if (userId != null) {
      userIdParameter = `&userId=${userId}`;
    }

    return axios
      .put(`${adminBaseUrl}/table-opening/re-open/${tableOpeningId}?restaurantId=${restaurantId}${userIdParameter}`, null, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
        let errorResponse = {
          error: true
        }
        return errorResponse;
      });
  },

  async reOrder(restaurantIds, payload, publishAndReceipt, language, userId, authToken, jwt) {

    let userIdParameter = "";
    if (userId != null) {
      userIdParameter = `&userId=${userId}`;
    }

    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .put(`${adminBaseUrl}/table-opening/repeat-order?restaurantIds=${restaurantIds}&publishAndReceipt=${publishAndReceipt}&language=${language}${userIdParameter}`, payload, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {

        let message = {
          GRE: "",
          ENG: "",
        };

        if (error.response) {
          console.log(error.response)
          message = getResponseMessage(error.response.data.message);
        } else {
          message.GRE = "Κάτι πήγε λάθος, δοκιμάστε ξανά";
          message.ENG = "Something went wrong, try again";
        }

        return {
          error: true,
          message: message,
        };

      });
  },
};
